// extracted by mini-css-extract-plugin
module.exports = {"container":"not_found_message_container__2IhPk","notFound":"not_found_message_notFound__1FxEJ"};